import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export class PortalContent extends Component {
  render() {
    if (!__CLIENT__) {
      return null;
    }

    const { id, children } = this.props;

    const domNode = document.querySelector(`[data-portal-id='${id}']`);

    if (!domNode) {
      return null;
    }

    return ReactDOM.createPortal(children, domNode);
  }
}

PortalContent.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
};
